<template>
    <div>
        <PageTop></PageTop>
        <button
            class="bg-bd text-14 px-4 py-1 text-bg block shadow-[2px_2px_2px_#ccc]"
            @pointerup="$router.push({name:'userIndex'})"
            >
                返回
            </button>
        <div class="text-16 text-center">
            南邓字花玩法<br>
            字花是一款猜谜题打一动物<br>
            字花每场<span class="text-red-600">88888</span>元人民币<br>
            每场只爆一次庄<br>
            最大注优先，领取奖金<br>
            倍率赔付<span class="text-red-600">1赔28倍</span><br>
            不开蜜蜂🐝动物<br>
            开彩时间缅甸<br>
            上场开奖时间<span class="text-red-600">中午12点</span><br>
            下场开奖时间<span class="text-red-600">晚上8点</span><br>
        </div>
    </div>
</template>
<script>
import PageTop from '@/components/PageTop.vue';

export default{
    components:{
        PageTop
    },
}
</script>
<style scoped>
</style>